// Shared helpers for working with the BuildDrawingCombosService payload
// (relations and their ask_options) on the React side. Kept separate from
// any single component so future consumers (e.g. download confirmation)
// don't have to re-derive the same predicates.

export const relationHasRenderableOptions = (relation) => {
  const hasAsks = relation.ask_options && relation.ask_options.length > 0;
  const hasMaterials = relation.materials && (
    (relation.materials.groups && relation.materials.groups.length > 0) ||
    relation.materials.ask_custom_material
  );
  return hasAsks || hasMaterials;
};

// Mirrors the host's sort: not-advanced first, advanced second; within each
// partition by sort_order desc. Advanced options are only included when the
// host-level "Show advanced options" toggle is on.
export const visibleAskOptions = (askOptions, advancedOptionsVisible) => {
  const bySortOrderDesc = (a, b) => (b.sort_order || 0) - (a.sort_order || 0);
  const notAdvanced = askOptions.filter((option) => !option.advanced).sort(bySortOrderDesc);
  if (!advancedOptionsVisible) { return notAdvanced; }
  const advanced = askOptions.filter((option) => option.advanced).sort(bySortOrderDesc);
  return [...notAdvanced, ...advanced];
};
